import React, { useState } from "react";
import { CmpSignPageContent } from "../../../components/organisms/CmpPageContent/cmpSignContent/index";
import { CmpTemplates } from "../../../components/template/CmpTemplates";
import { useRecoilState } from "recoil";
import { userSignState } from "../../../states/user-sign-up";
import { useNavigate } from "react-router";

export const CmpSignPages = () => {
  const navigate = useNavigate();
  const [userSignUpData, setUserSignUpData] = useRecoilState(userSignState);
  const [isCheck, setIsCheck] = useState<boolean>(
    userSignUpData.userInfo.userAgreement
  );

  // 다음 버튼
  const onNextStepHandler = () => {
    setUserSignUpData((prev: any) => ({
      ...prev,
      userInfo: {
        ...prev.userInfo,
        userAgreement: isCheck,
      },
    }));

    navigate("/cmp-cargo-insur-page");
  };

  // 이전 버튼
  const onBackHandler = () => {
    navigate(-1);
  };

  return (
    <CmpTemplates pageTitle="회원가입">
      <CmpSignPageContent
        onNextStepHandler={onNextStepHandler}
        onBackHandler={onBackHandler}
        setIsCheck={setIsCheck}
        isCheck={isCheck}
      />
    </CmpTemplates>
  );
};
